export default __webpack_public_path__ + "static/img4-e4b25297b66f3a9667539a446df7ae52.jpg";